export const GUEST_TRAINER_STORAGE_KEY = 'guestTrainerSession';
export const GUEST_QUIZ_STORAGE_KEY = 'guestPracticeQuiz';

export function saveGuestTrainerSession(session) {
  sessionStorage.setItem(GUEST_TRAINER_STORAGE_KEY, JSON.stringify(session));
}

export function loadGuestTrainerSession() {
  try {
    const raw = sessionStorage.getItem(GUEST_TRAINER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function saveGuestQuiz(quiz) {
  sessionStorage.setItem(GUEST_QUIZ_STORAGE_KEY, JSON.stringify(quiz));
}

export function loadGuestQuiz() {
  try {
    const raw = sessionStorage.getItem(GUEST_QUIZ_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}
